import script from "./FacilityList.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityList.vue?vue&type=script&setup=true&lang=js"

import "./FacilityList.vue?vue&type=style&index=0&id=39d51646&lang=css"

const __exports__ = script;

export default __exports__